import React from "react";
import { FormControl, InputLabel, Select, OutlinedInput, MenuItem, TextField, Button } from '@mui/material'
import withModal from '../../Modal';
import MemberAgeGroups from '../../../models/MemberAgeGroups';
import MemberGroupTypes from '../../../models/MemberGroupTypes';
import EventOptionAvailabilityTypes from '../../../models/EventOptionAvailabilityTypes';
import EventOptions from '../../../models/EventOptions';

const PriceModal = (props: any) => {

    let ageGroups: JSX.Element[] = (props.ageGroups as MemberAgeGroups[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.groupName} {x.groupAgeFrom} - {x.groupAgeTo}</MenuItem>
    })

    let groupTypes: JSX.Element[] = (props.groupTypes as MemberGroupTypes[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
    })

    let availabilityTypes: JSX.Element[] = (props.availabilityTypes as EventOptionAvailabilityTypes[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
    })

    let eventOptions: JSX.Element[] = (props.eventOptions as EventOptions[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
    })

    let memberGroupTypeValueError = true
    let memberGroupTypeValue
    if(props.method === 'Submit') {
        if(typeof props.newObject.newMemberGroupTypeIds !== 'undefined')
        {
            memberGroupTypeValue = props.newObject.newMemberGroupTypeIds
            memberGroupTypeValueError = false;
        }
        else {
            memberGroupTypeValue = []

        }
    } else {
        if(typeof props.newObject.memberGroupTypeId !== 'undefined')
            {
                memberGroupTypeValue = props.newObject.memberGroupTypeId
                memberGroupTypeValueError = false;
            }
        else
            memberGroupTypeValue = ''
    }

    let memberAgeGroupValueError =  !memberGroupTypeValueError && (!props.newObject.newMemberAgeGroupIds || !props.newObject.memberAgeGroupId);
    let memberAgeGroupValue;
    if(props.method === 'Submit') {
        if(typeof props.newObject.newMemberAgeGroupIds !== 'undefined'){ 
            memberAgeGroupValue = props.newObject.newMemberAgeGroupIds
            memberAgeGroupValueError = false;
        }
        else
            memberAgeGroupValue = []
    } else {
        if(typeof props.newObject.memberAgeGroupId !== 'undefined'){
            memberAgeGroupValue = props.newObject.memberAgeGroupId
            memberAgeGroupValueError = false;
        }
        else
            memberAgeGroupValue = ''
    }

    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-body'>
                        <div className='row'>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Teilnehmergruppe: *
                                            </InputLabel>
                                    <Select
                                        multiple={props.method === 'Submit'}
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name={props.method === 'Submit' ? 'newMemberGroupTypeIds' : 'memberGroupTypeId'}
                                        error={!props.requiredFields.memberGroupTypeId}
                                        value={memberGroupTypeValue}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em>--- bitte auswählen ---</em>
                                        </MenuItem>
                                        {groupTypes}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">Altersklasse: *</InputLabel>
                                    <Select
                                        multiple={props.method === 'Submit'}
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name={props.method === 'Submit' ? 'newMemberAgeGroupIds' : 'memberAgeGroupId'}
                                        error={memberAgeGroupValueError}
                                        value={memberAgeGroupValue}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em>--- bitte auswählen ---</em>
                                        </MenuItem>
                                        {ageGroups}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label='Beschreibung:'
                                    name='description'
                                    value={typeof props.newObject.description !== 'undefined' ? props.newObject.description : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}
                                    fullWidth
                                    multiline />
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Veranstaltung: *
                                            </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name='eventOptionId'
                                        error={!props.requiredFields.eventOptionId}
                                        value={typeof props.newObject.eventOptionId !== 'undefined' ? props.newObject.eventOptionId : ''}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em>--- bitte auswählen ---</em>
                                        </MenuItem>
                                        {eventOptions}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Verfügbarkeit: *
                                            </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name='availabilityId'
                                        error={!props.requiredFields.availabilityId}
                                        value={typeof props.newObject.availabilityId !== 'undefined' ? props.newObject.availabilityId : ''}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em>--- bitte auswählen ---</em>
                                        </MenuItem>
                                        {availabilityTypes}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label='Preis: *'
                                    name='priceValue'
                                    error={!props.requiredFields.priceValue}
                                    value={typeof props.newObject.priceValue !== 'undefined' ? props.newObject.priceValue.toString().replace('.', ',') : ''}
                                    onChange={(e:any) => {
                                        e.target.value = e.target.value.replace(',','.')
                                        props.changeNewObject(e)
                                    }}
                                    fullWidth />
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <Button
                            className='btn'
                            color='secondary'
                            variant='contained'
                            onClick={() => props.hide()}>
                            Abbrechen
                                </Button>
                        <Button
                            className='btn'
                            color='primary'
                            variant='contained'
                            onClick={() => props.submit()}>
                            Hinzufügen
                                </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(PriceModal)